// extracted by mini-css-extract-plugin
export default {"reloadButton":"s9Hqad","content":"jZ7zzU","textContainer":"s5Uast","textTitle":"YHlH9M","text":"KwQWSt"};